import { FC } from 'react'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { CheckmarkFilledIcon } from '@getgo/chameleon-icons/react'
import { MenuItem, MenuSection } from '@getgo/chameleon-web-react-wrapper'
import { Box, Grid, makeStyles } from '@material-ui/core'
import clsx from 'clsx'

import { useAccountContext } from 'components/contexts/AccountContext'
import { Account } from 'types/Account'

export interface MenuSection {
  title: string
  accounts: Account[]
}
const useStyles = makeStyles(() => ({
  menuSection: {
    margin: '0.25rem 1rem',
    display: 'flex',
    color: tokens.typeColorSecondary,
    font: tokens.captionMediumStrong,
  },
  menuSelected: {
    font: tokens.bodySmallStrong,
  },
}))

const Section: FC<MenuSection & { onClick: (account: Account) => void }> = ({ title, accounts, onClick, ...props }) => {
  const classes = useStyles()

  const { accountKey: currentAccountKey } = useAccountContext()

  return (
    <Grid container direction="column" alignItems="flex-start" {...props}>
      <MenuSection className={classes.menuSection}>{title}</MenuSection>
      {accounts.map((account) => (
        <MenuItem
          className={clsx(currentAccountKey === account.key && classes.menuSelected)}
          key={account.key}
          title={account.name}
          checked={currentAccountKey === account.key}
          leadingIcon={currentAccountKey === account.key ? <CheckmarkFilledIcon /> : <Box width={20} height={32} />}
          role="menuitem"
          onClick={() => onClick(account)}
        >
          {account.name}
        </MenuItem>
      ))}
    </Grid>
  )
}

export default Section
